import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@/services/axiosBaseQuery';

/** Every tag type the API uses; also what a role switch invalidates (see usersApi). */
export const API_TAG_TYPES = [
  'Document',
  'DocumentStats',
  'ReviewWorkflow',
  'RoleMatrix',
  'Employees',
  'AuditLog',
  'AuditRegisterLog',
  'ExternalAuditors',
  'Audits',
  'AuditRequestItems',
  'MrmMeetings',
  'Delegate',
  'Controls',
  'SOPMapping',
  'GapAnalysis',
  'Evidences',
  'EvidenceValidity',
  'EvidenceKPI',
  'Evidence',
  'EvidenceFiles',
  'Notifications',
  'EvidencePacks',
  'EligibleAuditors',
  'RiskAppetite',
  'Risks',
  'RiskTaxonomy',
  'IdentifiedRisks',
  'AuditReports',
  'AuditPreliminaryReport',
  'AuditFinalReport',
  'AuditFindings',
  'AuditRegistry',
  // Role-scoped data no other tag covers; a role switch refetches it (see usersApi).
  'RoleScoped',
] as const;

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: axiosBaseQuery,
  tagTypes: API_TAG_TYPES,
  endpoints: () => ({}),
});
